<template>
  <v-row :class="'text-' + position">
    <v-col :offset="offset" :cols="size" class="d-block">
      <div id="app">
        <div>
          <v-btn
            color="primary"
            class="text-none"
            rounded
            depressed
            :loading="isSelecting"
            @click="onButtonClick"
            :disabled="disabled"
          >
            <!-- <div v-if="anexo && anexo.name">
              <v-icon left> mdi-close-circle-outline </v-icon>
              {{ truncate(anexo.name) }}
            </div> -->
            <div v-if="previewInsideButton && anexo && anexo.name">
              <v-icon left> mdi-close-circle-outline </v-icon>
              {{ truncate(anexo.name) }}
            </div>

            <div v-else>
              <v-icon v-if="!onlyIcon" left> mdi-cloud-upload </v-icon>
              <v-icon v-else center> mdi-cloud-upload </v-icon>
              <span v-if="!onlyIcon">{{ label }}</span>
            </div>
          </v-btn>
          <input
            ref="uploader"
            class="d-none"
            type="file"
            :accept="accept"
            @click="$refs.uploader.value = null"
            @change="onFileChanged"
            @cancel="onFileChanged"
          />
        </div>
      </div>
    </v-col>
    <v-col v-if="showInfo" cols="12" class="d-block">
      <div>
        Só poderá anexar arquivo no(s) formato(s):
        <strong>{{ formats }}</strong>
      </div>
      <div>
        O tamanho do arquivo deverá ser no máximo de:
        <strong>{{ maxSize }}MB</strong>
      </div>
      <div>
        Só poderá ser anexado
        <strong>01</strong> arquivo
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "UploadFileComponent",
  props: {
    label: {
      type: String,
      default: "Envie um arquivo",
    },
    showInfo: {
      type: Boolean,
      default: false,
    },
    onlyIcon: {
      type: Boolean,
      default: false,
    },
    formats: {
      type: String,
      default: "JPEG, JPG, PNG, BMP e PDF",
      // default: "JPEG, JPG, PNG, BMP, PDF, DOCX, MP3, MP4 e ZIP",
    },
    maxSize: {
      type: Number,
      default: 2,
    },
    size: {
      type: Number,
      default: 12,
    },
    offset: {
      type: Number,
    },
    anexo: {
      default: null,
    },
    position: {
      type: String,
      default: 'center'
    },
    resetAfterUpload: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    previewInsideButton: {
      type: Boolean,
      default: true,
    }

  },
  data: () => ({ isSelecting: false }),
  computed: {
    /**
     * Converte a string da props 'format' para o formato que atributo 'accept' do input file aceita
     * Esse método identifica apenas string separada por ", " ou por "e "
     * Exemplo: "JPEG, JPG, PNG, BMP e PDF" => ".jpeg, .jpg, .png, .bmp, .pdf"
     * @returns {string}
     */
    accept() {
      let stringSplit = this.formats.split('e ').join(', ').split(', ');
      let stringConvertida = stringSplit.map(part => '.' + part.replace(' ', '').replace('.', '').toLowerCase());
      return stringConvertida.join(', ');
    },
    format() {
      return this.maxSize > 1 ? 'MB' : 'KB';
    },
    toKBSize() {
      return this.maxSize < 1 ? (this.maxSize * 1000) : this.maxSize;
    },
  },
  methods: {
    truncate(name, maxLength = 16) {
      const extension = name.split('.').pop();
      const baseName = name.slice(0, name.lastIndexOf('.'));
      if (baseName.length <= maxLength) {
        return name;
      }
      return `${baseName.slice(0, maxLength)}-.${extension}`;
    },
    onButtonClick() {
      this.isSelecting = true;
      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      const file = e.target.files[0];
      this.isSelecting = false;
      if (file) {
        if (this.validarFormatoDoArquivo(file)) {
          return this.$notifyError(`Selecione um arquivo em formato ${this.formats}.`);
        }
        if (this.validarTamanhoMinimoArquivo(file)) {
          return this.$notifyError(`Selecione um arquivo com um tamanho maior que 0KB!`);
        }
        if (this.validarTamanhoArquivo(file)) {
          return this.$notifyError(`Selecione um arquivo de até ${this.toKBSize}${this.format}.`);
        }
      }
      this.setAnexo(file || null);
      if (this.resetAfterUpload) {
        this.resetInput();
      }
    },
    resetInput() {
      this.$nextTick(() => {
        this.$refs.uploader.value = null;
        this.anexo = null;
        this.$forceUpdate();
      });
    },
    setAnexo(file) {
      this.anexo = file;
      this.$emit("input", this.anexo);
    },

    validarFormatoDoArquivo(file) {
      if (file) {
        const fileExtension = file.name.split('.').pop().toLowerCase();
        return !this.accept.split(',').map(ext => ext.trim().toLowerCase()).includes(`.${fileExtension}`);
      }
      return false;
    },
    validarTamanhoArquivo(file) {
      const maxSizeBytes = this.maxSize * 1024 * 1024;
      return maxSizeBytes <= file.size;
    },
    validarTamanhoMinimoArquivo(file) {
      return !file.size;
    }
  },
};
</script>
<style scoped>
.v-icon--left {
  margin-right: 8px;
}
</style>